var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutHeaderFooter',{attrs:{"bg":['none', '#F6F6F9'],"header":{ titleLabel: 'Extrato de utilização dos serviços assistenciais (PIN - SS)' }}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }